// client/src/pages/Admin/ResourceManager/components/ResourceStats.tsx

import React from 'react';
import { Layers, CheckCircle2, Eye, Download } from 'lucide-react';

interface StatCard {
  label: string;
  value: number;
  icon: React.ComponentType<{ size?: number }>;
  color: string;
  bgColor: string;
}

interface ResourceStatsProps {
  stats: StatCard[];
}

export const ResourceStats: React.FC<ResourceStatsProps> = ({ stats }) => {
  return (
    <div className="stats-grid">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div key={index} className="stat-card">
            <div className="stat-card-icon" style={{ backgroundColor: stat.bgColor, color: stat.color }}>
              <Icon size={20} />
            </div>
            <div className="stat-card-content">
              <span className="stat-card-label">{stat.label}</span>
              <span className="stat-card-value">{stat.value}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};